import React from 'react';

const AppointmentScheduler = () => (
  <div>
    <h1 className="page-title">Schedule Appointments</h1>
    <p>Appointment scheduling will appear here.</p>
  </div>
);

export default AppointmentScheduler;
